import { SearchState } from '@reducers/search';
import { GeoLevel, getGeoInclusionLabel } from '@sbt-web/networking';
import { CategoryID } from '@sbt-web/network/types';

export enum SEOTag {
  H1,
  TITLE,
  TITLE_WITH_QUERY,
  META_DESCRIPTION,
}

export function getGeoLabel(
  search: SearchState,
  geoLevel: GeoLevel | null,
  tag: SEOTag
): string {
  const inclusionLabel = getGeoInclusionLabel(geoLevel ?? GeoLevel.Italia);

  switch (geoLevel) {
    case GeoLevel.Town: {
      return substringsBySEOTag[tag][geoLevel as GeoLevel](
        inclusionLabel,
        search.geo?.town?.value as string,
        search.geo?.city?.shortName as string
      );
    }
    case GeoLevel.City: {
      return substringsBySEOTag[tag][geoLevel as GeoLevel](
        inclusionLabel,
        search.geo?.city?.value as string
      );
    }
    case GeoLevel.Region: {
      return substringsBySEOTag[tag][geoLevel as GeoLevel](
        inclusionLabel,
        search.geo?.region?.value
      );
    }
    case GeoLevel.RegionAndNearRegions: {
      return substringsBySEOTag[tag][geoLevel as GeoLevel](
        inclusionLabel,
        search.geo?.region?.value
      );
    }
    case GeoLevel.Italia:
    case null: {
      return substringsBySEOTag[tag][geoLevel as GeoLevel](
        inclusionLabel,
        search.category.id
      );
    }
  }
}

const substringsBySEOTag: Record<
  SEOTag,
  Record<GeoLevel, (...args: string[]) => string>
> = {
  [SEOTag.H1]: {
    [GeoLevel.Town]: (inclusionLabel, townValue, cityShortName) => {
      return `${inclusionLabel} ${townValue} (${cityShortName})`;
    },
    [GeoLevel.City]: (inclusionLabel, cityValue) => {
      return `${inclusionLabel} ${cityValue} e provincia`;
    },
    [GeoLevel.Region]: (inclusionLabel, regionValue) => {
      return `${inclusionLabel} ${regionValue}`;
    },
    [GeoLevel.RegionAndNearRegions]: (inclusionLabel, regionValue) => {
      return `${inclusionLabel} ${regionValue} e vicinanze`;
    },
    [GeoLevel.Italia]: (inclusionLabel, categoryId) => {
      if (categoryId == CategoryID.Tutte) {
        return `${inclusionLabel} tutta Italia`;
      }
      return '';
    },
  },

  [SEOTag.META_DESCRIPTION]: {
    [GeoLevel.Town]: (inclusionLabel, townValue) => {
      return ` ${inclusionLabel} ${townValue}`;
    },
    [GeoLevel.City]: (_, cityValue) => {
      return ` a ${cityValue} e provincia`;
    },
    [GeoLevel.Region]: (inclusionLabel, regionValue) => {
      return ` ${inclusionLabel} ${regionValue}`;
    },
    [GeoLevel.RegionAndNearRegions]: (_, regionValue) => {
      return ` in ${regionValue} e vicinanze`;
    },
    [GeoLevel.Italia]: () => {
      return '';
    },
  },
  [SEOTag.TITLE]: {
    [GeoLevel.Town]: (_, townValue) => {
      return townValue;
    },
    [GeoLevel.City]: (_, cityValue) => {
      return `${cityValue} e provincia`;
    },
    [GeoLevel.Region]: (_, regionValue) => {
      return regionValue;
    },
    [GeoLevel.RegionAndNearRegions]: (_, regionValue) => {
      return `vicino ${regionValue}`;
    },
    [GeoLevel.Italia]: () => {
      return '';
    },
  },
  [SEOTag.TITLE_WITH_QUERY]: {
    [GeoLevel.Town]: (inclusionLabel, townValue) => {
      return `${inclusionLabel} ${townValue}`;
    },
    [GeoLevel.City]: (inclusionLabel, cityValue) => {
      return `${inclusionLabel} ${cityValue} e provincia`;
    },
    [GeoLevel.Region]: (inclusionLabel, regionValue) => {
      return `${inclusionLabel} ${regionValue}`;
    },
    [GeoLevel.RegionAndNearRegions]: (inclusionLabel, regionValue) => {
      return `${inclusionLabel} ${regionValue} e vicinanze`;
    },
    [GeoLevel.Italia]: (inclusionLabel, categoryId) => {
      if (categoryId == CategoryID.Tutte) {
        return `${inclusionLabel} tutta Italia`;
      }
      return '';
    },
  },
};
